/* src/app/components/info-pasar-pagina/info-pasar-pagina.component.scss */
.back-img {
  width: 350px;
  height: 620px;
  max-width: 100%;
  max-height: 100%;
  background-image: url("./media/orientacion-ODUJBIU3.png");
  background-repeat: no-repeat;
  background-size: 100%, auto;
  overflow: hidden !important;
}
ion-icon {
  --ionicon-stroke-width: 44px;
}
/*# sourceMappingURL=info-pasar-pagina.component-HGMH52KG.css.map */
